/*
  Nastavitve aplikacije.

  Supabase anon ključ je javen po naravi — konča v JS paketu, ki ga dobi
  vsak brskalnik. Varnost stoji na RLS in trigerjih v bazi, ne na skrivanju
  tega ključa. Zato je privzeta vrednost tu v redu: če okoljske spremenljivke
  niso nastavljene, se deploy ne zlomi.
*/

const env = import.meta.env ?? {};

export const SUPABASE_URL = env.VITE_SUPABASE_URL || 'https://qhzrtpkfayresklpqrdt.supabase.co';

export const SUPABASE_ANON_KEY =
  env.VITE_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFoenJ0cGtmYXlyZXNrbHBxcmR0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4NDI2ODIsImV4cCI6MjA5MzQxODY4Mn0.WNiyUIlMXuSYV7gVqWvi21tXje__j_2bv1ir_ul2grw';

/** Edini admin. Isti naslov je zapisan v trigerjih v bazi. */
export const ADMIN_EMAIL = 'lukas.felicijan@gmail.com';

/** Ločena aplikacija s teoretičnimi vprašanji. */
export const VPRASANJA_URL = 'https://izpitna-vprasanja.netlify.app';

/** Uradni učbenik, javni bucket Assets. */
export const UCBENIK_URL =
  'https://qhzrtpkfayresklpqrdt.supabase.co/storage/v1/object/public/Assets/Ucbenik_jadralnih_padal.pdf';

export const PERUT_LOGO =
  'https://qhzrtpkfayresklpqrdt.supabase.co/storage/v1/object/public/Assets/Perut%20Paragliding%20LOGO.svg';

/*
  Pogoji za izpit.
  ⚠️ Te vrednosti čakajo Lukovo potrditev (glej HANDOFF.md).
  Vir: učbenik, 25. člen uredbe + nadaljevalni program.
*/
export const IZPIT_MIN_LETOV = 50;
export const IZPIT_MIN_STAROST = 16;

/** Leti morajo biti opravljeni na vsaj toliko različnih vzletiščih. */
export const IZPIT_MIN_VZLETISC = 5;

/**
 * Zahtevana višinska razlika leta v metrih.
 * ⚠️ Aplikacija tega NE preverja — pri letu ni polja za višinsko razliko.
 * Vrednost je tu samo zato, da jo lahko izpišemo v pogojih.
 */
export const IZPIT_MIN_VISINSKA_RAZLIKA = 150;

/** Prijavnico izda Agencija za civilno letalstvo. */
export const ACL_NASLOV = 'Javna agencija za civilno letalstvo\nKotnikova ulica 19A\nSI-1000 Ljubljana';
export const ACL_URL = 'https://www.caa.si';
export const PERUT_EMAIL = 'info@perut.net';
export const PERUT_TELEFON = '+386 40 616 653';
export const PERUT_NASLOV = 'Ribarjeva ulica 5, 3000 Celje';
export const PRIJAVA_BLOG_URL = 'https://www.perut.net/blog/solanje-5/prijava-na-izpit-5';

/**
 * Uradni obrazec agencije. Hranimo ga v repu (`public/obrazci/`), da ga
 * tečajnik dobi z enim klikom in ne išče po straneh agencije.
 * ⚠️ Če agencija izda novo različico, zamenjaj datoteko v repu.
 */
export const PRIJAVNICA_URL = '/obrazci/FCL.APL-139-prijava-na-izpit.docx';
export const PRIJAVNICA_IME = 'FCL.APL-139';

/** Izpitni roki — živ dokument agencije, zato povezava in ne kopija. */
export const IZPITNI_ROKI_URL =
  'https://www.caa.si/files/www%20-%20FCL/Izpitni%20roki%20za%20teoreti%C4%8Dno%20preverjanje%20znanja.pdf';

/** Zdravniško spričevalo ne sme biti starejše od toliko mesecev. */
export const ZDRAVNISKI_VELJAVNOST_MESECEV = 24;

/** Največja dovoljena velikost naloženega dokumenta (po stiskanju). */
export const MAX_DOC_BYTES = 8 * 1024 * 1024;

/** Slike se pred nalaganjem pomanjšajo na to največjo stranico. */
export const DOC_IMAGE_MAX_PX = 2000;

/* ── Več šol ───────────────────────────────────────────────
   Perut je prva šola s fiksnim ID-jem (glej migracijo sole_vec_sol). Vsi
   obstoječi zapisi spadajo vanjo.                                     */
export const PERUT_SOLA_ID = '00000000-0000-0000-0000-000000000001';

/** Javna stran za šole in obrazec za prijavo. */
export const ZA_SOLE_URL = '/za-sole';

/**
 * Paketi za šole (letna licenca, cene brez DDV). Vrednosti so izhodišče
 * za prodajo; platforma jih lahko za posamezno šolo prilagodi (plan,
 * velja_do, max_tecajnikov). Tečajniki ne plačujejo nič.
 */
export const PLANI = [
  { id: 'preizkus', ime: 'Preizkus', cena: 0, dni: 30, max: 10, opis: '30 dni, do 10 tečajnikov, vse funkcije.' },
  { id: 'mala', ime: 'Mala šola', cena: 490, max: 25, opis: 'Do 25 aktivnih tečajnikov, 2 inštruktorja.' },
  { id: 'sola', ime: 'Šola', cena: 990, max: 75, opis: 'Do 75 aktivnih tečajnikov, neomejeno inštruktorjev, lasten logotip.' },
  { id: 'center', ime: 'Center', cena: 1890, max: null, opis: 'Neomejeno tečajnikov, več lokacij, prednostna podpora.' },
  { id: 'interno', ime: 'Interno', cena: 0, max: null, opis: 'Lastna šola platforme.' },
];
